import { rect, type Point, type Rect, type Size } from '@geom';
import { SnorfLayout } from '@snorf';
import type { MeasuredText } from '@typography';
import { immerable } from '@utils';

// Class for runtime node layout information
export class NodeLayout {
  [immerable] = true;

  center: Point;
  size: Size;
  measuredTitle?: MeasuredText; // Cache for title rendering
  _opacity = 1; // For animations

  snorfLayout?: SnorfLayout;

  constructor(center: Point, size: Size, measuredTitle?: MeasuredText, opacity = 1) {
    this.center = center;
    this.size = size;
    this.measuredTitle = measuredTitle;
    this._opacity = opacity;
  }

  get bounds(): Rect {
    return rect({ center: this.center, size: this.size });
  }

  get opacity(): number {
    return this._opacity;
  }

  set opacity(value: number) {
    this._opacity = value;
    if (this.snorfLayout) {
      this.snorfLayout.opacity = value;
    }
  }
}
